export const homeUrl = 'https://www.venmo.com'
export const authHomeUrl = 'https://account.venmo.com'

export const friendsAndSocialUrl = 'https://account.venmo.com/settings/social'
export const privacyUrl = 'https://account.venmo.com/settings/privacy'
export const notificationsUrl =
  'https://account.venmo.com/settings/notifications'
